import React from 'react';
import Footer from '../components/Footer';

const Media = () => {
  const mediaImages = [
    {
      url: 'https://res.cloudinary.com/ditcmszc1/image/upload/v1769763264/Screenshot_2026-01-03_at_2.41.46_PM_ttaclj_lwmt6x.png',
      company: 'PickMyWork',
      link: 'https://www.bwpeople.in/article/pickmywork-to-empower-1-lakh-gig-workers-with-livelihood-432749'
    },
    {
      url: 'https://res.cloudinary.com/ditcmszc1/image/upload/v1769763267/Screenshot_2026-01-03_at_2.42.47_PM_ni50cr_lmfvwt.png',
      company: 'PickMyWork',
      link: 'https://www.entrepreneur.com/en-in/news-and-trends/pickmywork-raises-1-million-in-seed-funding/435183'
    },
    {
      url: 'https://res.cloudinary.com/ditcmszc1/image/upload/v1769763265/Screenshot_2026-01-03_at_2.43.04_PM_c2jy7v_zccvi1.png',
      company: 'Knocksense',
      link: 'https://www.vccircle.com/knocksenseraising-1-mn-in-pre-series-a-funding-gets-nazara-founder-s-backing'
    },
    {
      url: 'https://res.cloudinary.com/ditcmszc1/image/upload/v1769763265/Screenshot_2026-01-03_at_2.43.21_PM_qpzlbo_by5p1j.png',
      company: 'Knocksense',
      link: 'https://yourstory.com/2021/11/hyperlocal-content-platform-knocksense-raises-bridgeround'
    },
    {
      url: 'https://res.cloudinary.com/ditcmszc1/image/upload/v1769763265/Screenshot_2026-01-03_at_2.43.40_PM_rrcxqu_wg4dk8.png',
      company: 'YPay',
      link: 'https://yourstory.com/2021/08/funding-alert-fintech-startup-y-pay-raises-400k-led-we-circle-club'
    },
    {
      url: 'https://res.cloudinary.com/ditcmszc1/image/upload/v1769763265/Screenshot_2026-01-03_at_2.43.52_PM_p9lf4v_l4s49i.png',
      company: 'YPay',
      link: 'https://www.entrepreneur.com/en-in/finance/fintech-startup-ypay-raises-400000-bridge-round-from-we/380296'
    },
    {
      url: 'https://res.cloudinary.com/ditcmszc1/image/upload/v1769763266/Screenshot_2026-01-03_at_2.44.07_PM_q9u2dv_yxndvt.png',
      company: 'Zypp',
      link: 'https://economictimes.indiatimes.com/tech/funding/zypp-electric-raises-25-million-in-funding-led-by-taiwanese-ev-maker-gogoro/articleshow/97734815.cms?from=mdr'
    },
    {
      url: 'https://res.cloudinary.com/ditcmszc1/image/upload/v1769763266/Screenshot_2026-01-03_at_2.44.29_PM_dlwr0d_ni5l86.png',
      company: 'Zypp',
      link: 'https://inc42.com/buzz/zypp-electric-to-raise-25-30-mn-eyes-expansion-to-new-cities/'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl font-bold text-black mb-12 text-center opacity-0 animate-fade-in-up">MEDIA</h1>
          
          {/* Media Gallery */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {mediaImages.map((media, index) => (
              <a
                key={index}
                href={media.link}
                target="_blank"
                rel="noopener noreferrer"
                className={`group relative overflow-hidden rounded-lg shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-105 cursor-pointer ${
                  index % 4 === 0
                    ? 'bg-grey/10'
                    : index % 4 === 1
                    ? 'bg-lightBlue/10'
                    : index % 4 === 2
                    ? 'bg-darkBlue/10'
                    : 'bg-grey/20'
                }`}
              >
                <div className="p-4">
                  <img
                    src={media.url}
                    alt={`${media.company} media coverage`}
                    className="w-full h-auto object-cover rounded"
                  />
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-white text-sm font-semibold">{media.company}</p>
                  <p className="text-white text-xs mt-1">Read Article →</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Media;

